import ChatHomePage from "./ChatHomePage";

export default ChatHomePage;
